const mobMenuSpinner = document.getElementById('mobmenu-spinner');
const mobMenuMakeString = `${url}/makes?subscription-key=${key}`;
const mobMenuRegoFilters = document.getElementById('mob-menu-rego-filters');
const mobMenuRego = document.getElementById('mob-menu-rego');
const mobMenuRegoSearch = document.getElementById('mob-menu-regoSearch');
const mobMenuStates = document.getElementById('mob-menu-states');
const mobMenusbr = document.getElementById('mob-menu-sbr');
const mobMenuVehicleFilters = document.getElementById('mob-menu-vehicle-filters');
const mobMenuMake = document.getElementById('mob-menu-makes');
const mobMenuYear = document.getElementById('mob-menu-years');
const mobMenuModel = document.getElementById('mob-menu-models');
const mobMenuSeries = document.getElementById('mob-menu-series');
const mobMenuLookup = document.getElementById('mob-menu-lookup');
const mobMenusbv = document.getElementById('mob-menu-sbv');

//listener for rego use vehicle selector instead button
document.getElementById('choose').addEventListener('click', function () {
    if (!mobMenusbv.classList.value.includes('switchActive')) {
        mobMenuRegoFilters.style.display = 'none';
        mobMenuVehicleFilters.style.display = 'block';
        setTimeout(() => {
            mobMenuRegoFilters.style.opacity = 0;
        }, this.animationDelay + 10);
        setTimeout(() => {
            mobMenuVehicleFilters.style.opacity = 1;
        }, this.animationDelay + 20);
        mobMenusbr.classList.toggle('switchActive');
        mobMenusbv.classList.toggle('switchActive');
        mobMenusbr.classList.toggle('switchOff');
        mobMenusbv.classList.toggle('switchOff');
    }
});

//load data for dropdowns and check for locally stored selection data
document.addEventListener('DOMContentLoaded', function () {
    if (mobMenuVehicleFilters) {
        if (localStorage.getItem('makeList')) {
            mobMenuMake.innerHTML = localStorage.getItem('makeList');
            mobMenuMake.disabled = false;
            if (localStorage.getItem('makeSelection')) {
                mobMenuMake.selectedIndex = localStorage.getItem('makeSelection');
                makeMove(mobMenuMake,mobMenuYear,mobMenuModel,mobMenuSeries,mobMenuLookup);
            }
        } else {
            retrieveMakes(mobMenuMakeString, options, mobMenuSpinner, mobMenuMake);
        }

        //listen for inputs on dropboxes
        mobMenuMake.addEventListener('input', function () {
            storageWiper(6);
            dropDownSwitches(3,mobMenuSeries, mobMenuModel, mobMenuYear);
            makeMove(mobMenuMake,mobMenuYear,mobMenuModel,mobMenuSeries,mobMenuLookup,mobMenuSpinner);
        });

        mobMenuYear.addEventListener('input', function () {
            storageWiper(4);
            dropDownSwitches(2,mobMenuSeries, mobMenuModel, mobMenuYear);
            yearMove(mobMenuModel,mobMenuSeries,mobMenuLookup,mobMenuYear,mobMenuMake, mobMenuSpinner);
        });

        mobMenuModel.addEventListener('input', function () {
            storageWiper(2);
            dropDownSwitches(1,mobMenuSeries, mobMenuModel, mobMenuYear);
            modelMove(mobMenuSeries,mobMenuLookup,mobMenuModel,mobMenuYear, mobMenuSpinner);;
        });

        mobMenuSeries.addEventListener('input', function () {
            seriesMove(mobMenuSeries,mobMenuLookup);
        });

        //listen for click on search
        mobMenuLookup.addEventListener('click', function () {
            let vehicleID = mobMenuSeries.value;
            let reqString = `${url}/fitments/${vehicleID}?subscription-key=${key}`;
            localStorage.setItem('makeSelection', mobMenuMake.selectedIndex);
            localStorage.setItem('yearSelection', mobMenuYear.selectedIndex);
            localStorage.setItem('modelSelection', mobMenuModel.selectedIndex);
            localStorage.setItem('seriesSelection', mobMenuSeries.selectedIndex);
            searchVehicle(reqString, options, vehicleID, '', mobMenuSpinner, mobMenuMake, mobMenuYear, mobMenuModel, mobMenuSeries, mobMenusbv);
        });
    }
});
document.addEventListener('DOMContentLoaded', function () {
    if (mobMenuRegoFilters) {
        if (localStorage.getItem('regoString')) {
            mobMenuRego.value = localStorage.getItem('regoString');
            mobMenuStates.disabled = false;
            if (localStorage.getItem('regoState')) {
                mobMenuStates.selectedIndex = localStorage.getItem('regoState');
                stateActive(mobMenuRegoSearch,mobMenuSpinner,mobMenuRego,mobMenuStates,mobMenusbr,mobMenuMake,mobMenuYear,mobMenuModel,mobMenuSeries, mobMenusbv);
            }
        }
        //listener for rego and states inputs to enable/disable inputs and search button
        mobMenuRego.addEventListener('input', function () {
            if (mobMenuRego.value.length > 0) {
                mobMenuStates.disabled = false;
            } else if (mobMenuRego.value.length == 0) {
                mobMenuStates.disabled = true;
                mobMenuStates.selectedIndex = 0;
                mobMenuRegoSearch.style.cursor = 'none';
                mobMenuRegoSearch.style.opacity = '0.8';
                mobMenuRegoSearch.disabled = true;
            }
        });

        mobMenuStates.addEventListener('input', function () {
            if (mobMenuStates.value.length > 0) {
                stateActive(mobMenuRegoSearch,mobMenuSpinner,mobMenuRego,mobMenuStates,mobMenusbr,mobMenuMake,mobMenuYear,mobMenuModel,mobMenuSeries, mobMenusbv)
            } else if (mobMenuStates.value.length == 0) {
                mobMenuRegoSearch.style.cursor = 'none';
                mobMenuRegoSearch.style.opacity = '0.8';
                mobMenuRegoSearch.disabled = true;
                mobMenuRegoSearch.removeEventListener('click', function() {
                    onFind(mobMenuSpinner,mobMenuRego,mobMenuStates,mobMenusbr, mobMenuMake,mobMenuYear,mobMenuModel,mobMenuSeries, mobMenusbv);
                    //searchRego(mobMenuSpinner,mobMenuRego,mobMenuStates,mobMenusbr, mobMenuMake,mobMenuYear,mobMenuModel,mobMenuSeries, mobMenusbv);
                });
            }
        });
    }
});

//listeners to switch between vehicle and rego search
changeSearchListener(mobMenusbv, mobMenuVehicleFilters, mobMenuRegoFilters,mobMenusbr);
changeSearchListener(mobMenusbr, mobMenuRegoFilters, mobMenuVehicleFilters,mobMenusbv);